import { SAVE_MARGIN, SAVE_FUNDS } from '../../util/actionTypes';
const initialState = {data:[],funds:{}};

const marginReducer = (state =initialState, action) => {
    switch (action.type) {
   
        case SAVE_MARGIN: 
            return {
                ...state,
                data :action.payload, 
            };   
        case SAVE_FUNDS: 
            return {
                ...state,
                funds :action.payload, 
            };  
        default:
            return state;
    }
};

export default marginReducer;
